import { Component } from '@angular/core';

@Component({
  selector: 'app-search-panel',
  templateUrl: './search-panel.component.html'
})
export class SearchPanelComponent {

}
